export default "__VITE_ASSET__C7iGLg9P__"